/**
 * authcodemans service
 */

import Resource from './resource'

export default new Resource('authcodemans')



// WEBPACK FOOTER //
// ./src/libraries/services/authcodemans.js